import sgLogo from "assets/images/sg-logo.png";
import * as React from "react";
import { SgHeader } from "components/layout/Header/SgHeader";
import { ROUTES } from "common/routes";
import { Link } from "react-router";

const Header: React.FunctionComponent = () => (
  <header>
    <nav className="navbar navbar-expand-xl navbar-light bg-white border-bottom">
      <div className="navbar-title">
        <Link to={ROUTES.HOME} className="navbar-title-link">
          <img src={sgLogo} alt="Logo SG" height="32" />
          <div className="navbar-title-divider"></div>
          <div className="navbar-service-name">Events</div>
        </Link>
      </div>
      <div className="d-flex align-items-center order-xl-1">
        <SgHeader currentLanguage={"en"} />
      </div>
      <div className="navbar-collapse justify-content-start collapse" id="main-navbar" />
    </nav>
  </header>
);

export default Header;
